// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"326":"0efebc4e","520":"ff8c0f3f","621":"2d480d4e","808":"d3dc7272"}[chunkId] + ".js";
};